// -------------------------------------------------- //
// -------------------------------------------------- //


// The "stacktrace" library that we included in the Scripts
// is now in the Global scope; but, we don't want to reference
// global objects inside the AngularJS components - that's
// not how AngularJS rolls; as such, we want to wrap the
// stacktrace feature in a proper AngularJS service that
// formally exposes the print method.
EMRAdmin.factory(
    "stacktraceService",
    function () {

        // "printStackTrace" is a global object.
        return ({
            print: printStackTrace
        });

    }
);


// -------------------------------------------------- //
// -------------------------------------------------- //


// By default, AngularJS will catch errors and log them to
// the Console. We want to keep that behavior; however, we
// want to intercept it so that we can also log the errors
// to the server for later analysis.
//EMRAdmin.provider("$exceptionHandler",
//{
//    $get: function (errorLogService) {

//        return (errorLogService.log);

//    }
//}
//);
EMRAdmin.factory('$exceptionHandler', ["errorLogService", function (errorLogService) {
    return function (exception, cause) {
        return (errorLogService.log(exception, cause));
    };
}]);

// -------------------------------------------------- //
// -------------------------------------------------- //


// The error log service is our wrapper around the core error
// handling ability of AngularJS. Notice that we pass off to
// the native "$log" method and then handle our additional
// server-side logging.
EMRAdmin.factory("errorLogService", ['$log', '$window', 'stacktraceService', '$base64', '$injector', function ($log, $window, stacktraceService, $base64, $injector) {

    var errorMessageCount = 0;
    var needToCheckVersionErrorMessage = "cannot open database";
    var adminTraceLogWCFPendingRequestsList = [];
    var adminTraceLogWCFAllPendingRequestsList = [];
    var apiErrorMailBoxAddresses = [{Address: "ehrerrors@adaptamed.org"}];
    //var adminTraceLogGetWCFRequestUIDInfoTakingTimeGreaterThanFiveSecsList = [];


    //$(document).on('logfiveseconds', function () {
    //	errorLog.adminTraceLogGetWCFRequestUIDInfoTakingTimeGreaterThanFiveSecs();
    //});

    function cleanUpHtml2CanvasIframes() {
        let canvasElements = document.querySelectorAll('.html2canvas-container');
        _.forEach(canvasElements, function (eachCanvasElement) {
            document.body.removeChild(eachCanvasElement);
        }); 
        

}

    function _getPendingRequests() {
        if (!adminTraceLogWCFPendingRequestsList || !adminTraceLogWCFPendingRequestsList.length) return [];
        const pendingRequests = adminTraceLogWCFAllPendingRequestsList.filter(function (request) {
            return !!request;
        });
        if (!pendingRequests || !pendingRequests.length) return [];
        return pendingRequests;
    }

    function _buildPendingRequestsHtml(pendingRequests) {
        var currentDateTime = adminGetCurrentDateAndTme();;
        let html = "<html><body>";
        html += "<B>Pending Requests     : </B> <br/>";
        html += "<table width=\"100%\" border=\"1\" ><tr style=\"color: #FFFFFF; background-color: #333333; font-weight: bold\">";
        html += "<td>Method URL</td>";
        html += "<td>Req.GUID</td>";
        html += "<td>Start Time</td>";
        html += "<td>Actual Time to Take(In Sec)</td>";
        html += "<td>Wait Time(In Sec)</td>";
        html += "<td>Internet Avail.</td>";
        html += "<td>Input JSON.</td>";
        html += "</tr>";
        pendingRequests.forEach(function (request) {
            html += "<tr>";
            html += `<td>${request.aMethodUrl}</td>`;
            html += `<td>${request.areqguid}</td>`;
            html += `<td>${request.starttime}</td>`;
            html += `<td>${request.atimeout / 1000}</td>`;
            var diff = DateDiff.inSeconds(request.starttime, currentDateTime);
            html += `<td>${diff} (${(diff / 60)} mins.)</td>`;
            html += `<td>${request.netavailable ? 'Yes' : 'No'}</td>`;
            html += `<td>${request.aData}</td>`;
            html += "</tr>";
        });
        html += "</table>";
        html += "</body></html>";
        return html;
    }

    function _getHtmlBytesFromString(htmlString) {
        if (!htmlString) return null;
        const utf8Encoder = new TextEncoder();
        const uint = utf8Encoder.encode(htmlString);
        return btoa(String.fromCharCode.apply(null, uint));
    }

    function _attachPendingRequestsInfoAsAttachment() {
        const pending = _getPendingRequests();
        if (!pending || !pending.length) return [];
        const html = _buildPendingRequestsHtml(pending);
        if (!html) return [];
        return [
            {
                AttachmentInBytes: _getHtmlBytesFromString(html),
                FileType: "text/html",
                FileName: `EMR_Pending_Requests_Info_${adminGetGUID()}_${new Date().toISOString()}.html`,
            }
        ]
    }

    function _buildAttachments(screenshotBinary) {
        let attachments = [];
        if (screenshotBinary) {
            attachments.push(
                {
                    AttachmentInBytes: screenshotBinary,
                    FileType: "image/gif",
                    FileName: `EMR_Error_Screenshot_${adminGetGUID()}_${new Date().toISOString()}.gif`,
                }
            );
        }
        const pending = _attachPendingRequestsInfoAsAttachment();
        if (pending && pending.length) {
            attachments = [...attachments, ...pending];
        }
        return attachments;
    }

    var errorLog = {
        //################SENDING ERROR MAIL WITH SCREEN SHOT BLOCK START########################

        errorLogServiceSendErrorMail: function (errorDetails, subjectSuffixAndPrefix) {
            //if no error message details then no need of sending the mail
            //if only Request Execution status is  -1 then only those are system generated errors other wise those user thrown errors  
            if (!errorDetails || !errorDetails.ErrorMessage || (errorDetails.RequestExecutionStatus && errorDetails.RequestExecutionStatus != -1)) return;

            if ([36, 999].includes(EMRPracticeModel && EMRPracticeModel.PracticeID) || window.location.href.indexOf("localhost") > 0 || window.location.href.indexOf("webqa-ehryourway.web.app") > 0 || window.location.href.indexOf("ehryourway-7daf3.web.app") > 0)
                return errorLog.openErrorInformationPopupForDevAndTestingEnvironments(errorDetails);

            html2canvas(document.body).then(function (canvas) {
                cleanUpHtml2CanvasIframes();
                //converting the current html web preview as base64
                var screenShotData = canvas.toDataURL("image/gif");

                //calling the method to send the mail
                errorLog.errorLogServiceSendMailToTechSupport(errorDetails, screenShotData, subjectSuffixAndPrefix);

            },
                function (reject) {
                    cleanUpHtml2CanvasIframes();
                    //calling the method to send the mail
                    errorLog.errorLogServiceSendMailToTechSupport(errorDetails, "", subjectSuffixAndPrefix);
                });

        },
        

        //this method is useful in sending the mail to the tech support with the formed html string body and the screen shot
        errorLogServiceSendMailToTechSupport: function (errorDetails, screenShotData, subjectSuffixAndPrefix) {


            if (!hasValue(errorDetails)) return false;

            if (!hasValue(errorDetails.practicemodel) && hasValue(errorDetails.data) && hasValue(errorDetails.data.practicemodel)) {
                errorDetails.practicemodel = errorDetails.data.practicemodel;
            }

            var subject = errorDetails && errorDetails.isAPI_RequestErrors ? 
                                "EMR WEB API Errors Information":
                                "AngularJS - UI Errors Information";

            if(!errorDetails || !errorDetails.practicemodel)
            {
                errorDetails = errorDetails || {}
                errorDetails.practicemodel = angular.copy(EMRPracticeModel);
            }

            if(EMRPracticeModel)
                subject = `${subject} ${EMRPracticeModel.PracticeName} - ${EMRPracticeModel.LoggedUserName}`;// + errorDetails.exceptionSystemName;




            if (hasValue(subjectSuffixAndPrefix)) {
                //APPENDING SUBJECT SUFFIX AND PREFIX TO SUBJECT
                subject = subjectSuffixAndPrefix + subject + subjectSuffixAndPrefix;
            }

            if (hasValue(EMRPracticeModel) && EMRPracticeModel.isEmergencyWeb) {
                subject = "Emergency " + subject;
            }


            //if no error message details then no need of sending the mail
           // if (!hasValue(errorDetails) || !hasValue(errorDetails.ErrorMessage)) return;

            //checking for the data base not opening message 
            if (hasValue(errorDetails) && hasValue(errorDetails.ErrorMessage) && errorDetails.ErrorMessage.toString().toLowerCase().indexOf(needToCheckVersionErrorMessage) > -1) {
                errorMessageCount++;
            }

            //if the count is > 10 then going to auto logout the system since db server may not be responding or may not be connecting or moved to some where
            if (errorMessageCount >= 10) {

                var currentRootScope = $injector.get("$rootScope");

                currentRootScope.$emit("homeCtrl.ehrCentralizerSocket", {
                    Type: EHRCentralizerMessageTypes.EHRVersionUpdatesAutoLogOff,
                    DisplayMessage: "",
                    autoLogoutReason: "Logged Out As Unable to Connect to Database for more than 10 Requests."
                });//calling the view to load
            }

            //if only Request Execution status is  -1 then only those are system generated errors other wise those user thrown errors  
        //    if (hasValue(errorDetails.RequestExecutionStatus) && errorDetails.RequestExecutionStatus != -1) return;


            //calling to form the error mail body
            var body = errorLog.errorLogServiceBuildErrorBody(errorDetails);
            
            if (errorDetails.customSubject)
                subject = errorDetails.customSubject;

            //trimming the screen shot data since to send the attachment we dont neeed the base64 in string
            if (hasValue(screenShotData)) {
                screenShotData = screenShotData.substring(screenShotData.indexOf("base64,") + "base64,".length);
            }

            //code moved to function openErrorInformationPopupForDevAndTestingEnvironments
            //no need to send the mail when in developement or testing environment required for WCF errors too soo
            // if (window.location.href.indexOf("localhost") > 0 || window.location.href.indexOf("192.168.0.15") > 0 ||
            //     window.location.href.indexOf("192.168.0.71") > 0 || window.location.href.indexOf("203.129.197.221") > 0 ||
            //     window.location.href.indexOf("192.168.0.87") > 0 || window.location.href.indexOf("192.168.0.56") > 0 || window.location.href.indexOf("weblocalalpha") > 0) {

            //     if (!hasValue(errorDetails.exceptionStackTrace))
            //         errorDetails.exceptionStackTrace = "";

            //     var template = '<div>' +
            //         '<div class="popup-header">' +
            //         '<i class="close pull-right" data-dismiss="modal" aria-hidden="true" ng-click="Cancel();"> ×</i>' +
            //         '<label class="ModalPopupHeadings">EMR Error Log Information</label>' +
            //         '</div>' +
            //         '<div class="modal-body">' +
            //         '<div class="row form-group">' +
            //         '<div class="col-md-12 col-sm-12 col-xs-12">' +
            //         '<textarea rows="5" class="form-control">' + errorDetails.ErrorMessage + '<br>' + errorDetails.exceptionStackTrace + '</textarea>' +
            //         '</div>' +
            //         '</div>' +
            //         '</div>' +
            //         '</div>';


            //     var modalPop = $injector.get('ModalPopupService');
            //     modalPop.OpenPopup(template, null, "lg").then(function () {

            //     });
            //     return;
            // }


            errorLog.sendAngularErrorMailstoAngularTechSupport(subject, body, _buildAttachments(screenShotData));
            /* //calling the mail sending method
            if(errorDetails && errorDetails.isAPI_RequestErrors)
               // errorLog.errorLogServiceSendMail(subject, body, screenShotData);
               errorLog.sendAngularErrorMailstoAngularTechSupport(subject, body, screenShotData, null, apiErrorMailBoxAddresses); 
            else
                errorLog.sendAngularErrorMailstoAngularTechSupport(subject, body, screenShotData); */

        },

        //this method is useful in forming the html string information that is necessary to send to the tech support 
        errorLogServiceBuildErrorBody: function (errorDetails) {


            /////////// #####        FORMING THE HTML BLOCK START  ###############////////////////

            var body = "<html><body>";

            body += "<B>Client Referrel URL    : </B> <br>" + window.location.href + "<br><br>";


            if (hasValue(EMRPracticeModel)) {
                body += "<B>Practice Info       : </B><br />  <br />";

                if (hasValue(EMRPracticeModel.PracticeName))
                    body += "<B>Practice Name     : </B> " + EMRPracticeModel.PracticeName + "<br>";

                body += "<B>Practice ID     : </B> " + EMRPracticeModel.PracticeID + "<br>";

                if (hasValue(EMRPracticeModel.LoggedUserName))
                    body += "<B>Logged UserName   : </B> " + EMRPracticeModel.LoggedUserName + "<br>";
            }


            //appending the date time
            if (hasValue(adminGetCurrentDateAndTime()))
                body += "<B>Date & Time       : </B> " + adminGetCurrentDateAndTime() + "<br><br>";
            else
                body += "<B>Date & Time       : </B> " + new Date() + "<br><br>";


            //appending the WCF error information
            if (hasValue(errorDetails.exceptionSystemName)) {
                body += "<B>WCF Error Info       : </B><br /> <br />";
                body += "<B>Error Message     : </B> <br>" + errorDetails.ErrorMessage + "<br><br>";

                if (hasValue(errorDetails.exceptionStackTrace))
                    body += "<B>Error Stack Trace : </B> <br>" + errorDetails.exceptionStackTrace + "<br><br> ";

                body += "<B>System Name       : </B> " + errorDetails.exceptionSystemName + "<br>";

                if (hasValue(errorDetails.inputObjectJSON))
                    body += "<B>Input Object JSON     : </B> <br>" + errorDetails.inputObjectJSON + "<br><br>";
                if (hasValue(errorDetails.exceptionJSON))
                    body += "<B>Exception JSON     : </B> <br>" + errorDetails.exceptionJSON + "<br><br>";
                if (hasValue(errorDetails.exceptionLog))
                    body += "<B>Exception Track Log     : </B> <br>" + errorDetails.exceptionLog + "<br><br>";

            }
            //forming the javascript error information
            else {
                body += "<B>JAVASCRIPT  Error Info       : </B><br /> <br />";

                body += "<B>Error Message     : </B> <br>" + errorDetails.ErrorMessage + "<br><br>";

                if (hasValue(errorDetails.exceptionStackTrace))
                    body += "<B>Error Stack Trace : </B> <br>" + errorDetails.exceptionStackTrace + "<br><br> ";

                if (hasValue(errorDetails.url))
                    body += "<B>WCF Request URL : </B> <br>" + errorDetails.url + "<br><br> ";

                if (hasValue(errorDetails.data))
                    body += "<B>Request Data : </B> <br>" + JSON.stringify(errorDetails.data) + "<br><br> ";
            }

            if (hasValue(errorDetails))
                body += "<B>Error Details : </B> <br>" + JSON.stringify(errorDetails) + "<br><br> ";

            //if javascript error  not found/not attached
            if (body.indexOf("JAVASCRIPT") < 0)
                body += "<B>JAVASCRIPT  Error Info       : </B><br /> <br />";



            body += "<B>Browser Info     : </B> <br>" + adminBrowserDetails +
                'Window Inner Reolution = width X height = ' + window.innerWidth + ' X ' + window.innerHeight + '<br>'
                + 'Window Outer Reolution = width X height = ' + window.outerWidth + ' X ' + window.outerHeight + '<br>'
                + 'Screen Reolution = width X height = ' + screen.width + ' X ' + screen.height + "<br><br>";

            // Network COnenction Info added
            try {
                var connectionObj = navigator.connection;
                if(connectionObj){
                    body += "<b>Network Connection Info     :</b> <br>";   
                    body += "downlink     : " + connectionObj.downlink + "<br>";   
                    body += "effectiveType     : " + connectionObj.effectiveType + "<br>";   
                    body += "rtt     : " + connectionObj.rtt + "<br>";   
                    body += "saveData     : " + connectionObj.saveData + "<br><br>";   
                }
            } catch (error) {
            }

            if (hasValue(EMRPracticeModel) && hasValue(EMRPracticeModel.clientIP))
                body += "<B>Client IP     : </B> " + EMRPracticeModel.clientIP + "<br><br>";

            if (hasValue(EMRPracticeModel) && hasValue(EMRPracticeModel.clientSystemLocalIP))
                body += "<B>Client Local IP     : </B> " + EMRPracticeModel.clientSystemLocalIP + "<br><br>";
            else if (hasValue(EHRClientSystemLocalIP))
                body += "<B>Client Local IP     : </B> " + EHRClientSystemLocalIP + "<br><br>";


            // commented by Swaraj B on 27 Dec, 2025
            // from now onwards we are not including them screenshot as inline image in the mail body
            // we are sending that as attachment only as binary
            // body += "<B><img src='" + screenShotData + "' />";//appending the screen shot of the error


            // commented by Swaraj B on 27 Dec, 2025
            // we are attaching this pending request info as attachment only
            /* var needToSendAsMailList = [];

            var currentDateTime = adminGetCurrentDateAndTme();

            if (adminTraceLogWCFPendingRequestsList != null && adminTraceLogWCFPendingRequestsList != undefined && adminTraceLogWCFPendingRequestsList.length > 0) {
                needToSendAsMailList = $.grep(adminTraceLogWCFPendingRequestsList, function (itemInLoop) {
                    return itemInLoop != null && itemInLoop != undefined;// && DateDiff.inSeconds(itemInLoop.starttime, currentDateTime) >= 1 * 60;
                });
            }

            var needToSendAsMailListLooplength = needToSendAsMailList.length;

            if (needToSendAsMailListLooplength > 0) {
                body = body + "<B>Pending Requests     : </B> <br/>";
                body = body + "<table width=\"100%\" border=\"1\" ><tr style=\"color: #FFFFFF; background-color: #333333; font-weight: bold\">";
                body = body + "<td>" + "Method URL" + "</td>";
                body = body + "<td>" + "Req.GUID" + "</td>";
                body = body + "<td>" + "Start Time" + "</td>";
                body = body + "<td>" + "Actual Time to Take(In Sec)" + "</td>";
                body = body + "<td>" + "Wait Time(In Sec)" + "</td>";
                body = body + "<td>" + "Internet Avail." + "</td>";
                body = body + "<td>" + "Input JSON." + "</td>";
                body = body + "</tr>";

                for (var indexInLoopMethod = 0; indexInLoopMethod < needToSendAsMailListLooplength; indexInLoopMethod++) {
                    var currentElementRequest = needToSendAsMailList[indexInLoopMethod];
                    body = body + "<tr >";
                    body = body + "<td>" + currentElementRequest.aMethodUrl + "</td>";
                    body = body + "<td>" + currentElementRequest.areqguid + "</td>";
                    body = body + "<td>" + currentElementRequest.starttime + "</td>";
                    body = body + "<td>" + currentElementRequest.atimeout / 1000 + "</td>";
                    var differencesecs = DateDiff.inSeconds(currentElementRequest.starttime, currentDateTime);
                    body = body + "<td>" + differencesecs + " (" + (differencesecs / 60) + " mins.)" + "</td>";
                    body = body + "<td>" + (currentElementRequest.netavailable ? 'Yes' : 'No') + "</td>";
                    body = body + "<td>" + (currentElementRequest.aData) + "</td>";
                    body = body + "</tr>";
                }
                body = body + "</table>";

            } */

            body += "</body></html>";

            /////////// #####        FORMING THE HTML BLOCK END  ###############////////////////

            return $base64.encode(body);//returning the base64 formatted string
        },


        //this methdo is useful in calling the rest service to send the mail to the tech support emr
        //http://www.myxpertemr.com/EMR_ErrRptMsg/SendMessage.asmx
        //http://localhost/XpertEMR_Messages_ErrorReport/website/SendMessage.asmx/SendErrorMessagetoTechSupportWithAttachment_Web
        errorLogServiceSendMail: function (subject, body, attachmentBase64String) {

            if (!hasValue(subject) || !hasValue(body) || !hasValue(attachmentBase64String)) return;
            let wcfUrl = EMRCommonService + "SendJavaScriptErrorMails";
            let headers = {};
            wcfUrl = errorLog.verifyandHandleGatewayChanges(wcfUrl, headers);
            //making an jquery asynchronous call to send the mail when not in developement
            //if (window.location.href.indexOf("localhost") < 0 || window.location.href.indexOf("weblocalalpha") < 0) {
            $.ajax({
                type: "POST",
                url: wcfUrl,
                data: JSON.stringify({ "mailSubject": subject, "mailBody": body, "mailAttachmentInBase64Format": attachmentBase64String, "practicemodel": EMRPracticeModel }),
                success: function (success) {
                    //console.log(success);
                },
                error: function (errorThrown) {
                    // console.log(errorThrown);
                },
                headers,
                contentType: "application/json",
                dataType: 'json'
            });
            //}
        },

        
        /**
         * 
         * @param {string} subject 
         * @param {string} body 
         * @param {Array} attachments 
         * @description This func is to send mails angular errors to angular tech suport
         */
        //  sendAngularErrorMailstoAngularTechSupport: function (subject, body, attachments, wcfUrl, toMails) {
         sendAngularErrorMailstoAngularTechSupport: function (subject, body, attachments) {
            let GoogleCloudFunctionHandlerService = $injector.get('GoogleCloudFunctionHandlerService');
            if (!subject || !body || !attachments || !attachments.length) return;
            // callng a func to get PRIMARY WEB SERVER URL
            // var primaryWCFURL = errorLog.getPrimaryWCFURL()
            // //var _CommonPostService = $injector.get("CommonPostService");
            // if(!primaryWCFURL) return;
            // wcfUrl = `${primaryWCFURL}EHR_SendMailAPI/EHRMailController/SendAngularjsErrortoTechSupport`;
            // let headers = {};
            // wcfUrl = errorLog.verifyandHandleGatewayChanges(wcfUrl, headers);
            // $.ajax({
            //     type: "POST",
            //     // url: `${_CommonPostService.EHR_SendMail()}SendAngularjsErrortoTechSupport`,
            //     url: wcfUrl,
            //     data: JSON.stringify({ "MailSubject": subject, 
            //                             "MailBody": body, 
            //                             "MailAttachmentinBase64String": attachmentBase64String,
            //                             toMails
            //                             // "FromMail": {"Address":"techsupport@adaptamed.org"},
            //                             // "ToMails":[{"Address":"angularjstechsupport@adaptamed.org"}]
            //     }),
            //     headers,
            //     success: function (success) {
            //         //console.log(success);
            //     },
            //     error: function (errorThrown) {
            //         // console.log(errorThrown);
            //     },
            //     contentType: "application/json",
            //     dataType: 'json'
            // });
             let requestBody = {
                 "MailSubject": subject,
                 "MailBody": body,
                 MailAttachments: attachments,
                //  "MailAttachmentinBase64String": attachmentBase64String,
                 "toMails":[]
             }

             GoogleCloudFunctionHandlerService.post("EHR_SendAngularjsErrortoTechSupport_GCloudFunc", requestBody).then(function (response) {
                 if (isError(response)) {
                     return;
                 }
             })
            //}
        },

        /**
         * @description tHIS FUNC S TO RETURN EHR ALICATION PRIMARY WEB SERVER URL
         * FROM THE EMRCommonService URL BCZ IT HOLDS THE PRIMARY WEB SERVER URL FROM THE HOME PAGE LOADNG ITSELF
         * @returns {string} as EHR ALICATION PRIMARY WEB SERVER URL
         */
        getPrimaryWCFURL: function() {
            if(!EMRCommonService) return;
            var primaryWCFURL = angular.copy(EMRCommonService);
            primaryWCFURL = primaryWCFURL.replace("https://", "");
            primaryWCFURL = primaryWCFURL.replace("http://", "");
            var urlArr = primaryWCFURL.split("/");
            if (urlArr && urlArr.length > 0) {
                if (primaryWCFURL.indexOf("gateway") > -1)
                    return `https://${urlArr[0]}/${urlArr[1]}/`;
                else
                    return "https://" + urlArr[0] + "/";
            }
            else return "";
        },
        verifyandHandleGatewayChanges: function (url, headers) {
            var CommonPostService = $injector.get('CommonPostService');
            let accessToken = CommonPostService.getJWTAccesToken()
            if (url.indexOf('gateway') !== -1) {
                if (accessToken)
                    headers.Authorization = `Bearer ${accessToken}`;
                return url;
            }
            if (accessToken && !EMRPracticeModel.isEmergencyWeb && EMRPracticeModel.emrurlsmodel && EMRPracticeModel.emrurlsmodel.APIGateWayURLList &&
                EMRPracticeModel.emrurlsmodel.APIGateWayURLList.length > 0) {
                try {
                    const urlObj = new URL(url);
                    var newMethodURL = urlObj.pathname.slice(1);  //removing first "/" as it will be appended from api domain;
                    newMethodURL = `${EMRPracticeModel.emrurlsmodel.APIGateWayURLList[0].APIURL}${newMethodURL}`;
                    headers.Authorization = `Bearer ${accessToken}`;
                    url = newMethodURL;
                }
                catch (err) {

                }
                return url;
            }
            else return url;
        },

        // I log the given error to the remote server.
        log: function (exception, cause) {

            // Pass off the error to the default error handler
            // on the AngualrJS logger. This will output the
            // error to the console (and let the application
            // keep running normally for the user).
            $log.error.apply($log, arguments);

            // Now, we need to try and log the error the server.
            // --
            // NOTE: In production, I have some debouncing
            // logic here to prevent the same client from
            // logging the same error over and over again! All
            // that would do is add noise to the log.
            try {

                var errorMessage = exception.toString();
                
                if (errorMessage == "Possibly unhandled rejection: 403errorignoreerrormailsending" || errorMessage == "403errorignoreerrormailsending")
                    return;

                var stackTrace = stacktraceService.print({ e: exception });

                //adding the cause of the execption also to the error message to send as the mail
                if (hasValue(cause)) {
                    errorMessage = errorMessage + "<br /><br />cause : <br />" + cause;
                }


                // Log the JavaScript error to the server.
                // --     
                // NOTE: In this demo, the POST URL doesn't
                // exists and will simply return a 404.

                // ShowErrorMessage("An Error Occurred While Processing Your Request, Please Contact Support Team for Further Assistance.");

                //############SEND MAIL WITH SCREEN SHOT WHEN ERROR OCCURED BLOCK START##########################
                var responseObject = {
                    practicemodel: EMRPracticeModel,
                    ErrorMessage: errorMessage,
                    exceptionStackTrace: stackTrace
                };

                //TO IGNORE THE JAVASCRIPT ERRORS LIST
                var errorIgnoreSendListInService = ["$digest", "$apply", "[alert alert-success]", "expression [Success!] starting", "unexpected token", "TypeError: Cannot read property 'childNodes' of undefined", "TypeError: Cannot read property '_start' of undefined", "$sceDelegate policy. URL:", "TypeError: Cannot read property 'get' of undefined", "TypeError: n.injector(...) is undefined", "TypeError: Cannot read property 'removeClass' of undefined"];

                responseObject.ErrorMessage += "<br><br> Excepton ignore List checking code Reached...";
                for (var ignoreIndex = 0; ignoreIndex < errorIgnoreSendListInService.length; ignoreIndex++) {
                    if (errorMessage.toLowerCase().indexOf(errorIgnoreSendListInService[ignoreIndex].toLowerCase()) > -1){
                        responseObject.ErrorMessage += "<br> Excepton ignore List 1 Checking done...";
                        return false;
                    }
                }
                // WHILE CHANGING THE COLUMNS IN THE SCHEULER APPT. VIEW THEN USER HAVE TO LOGOUT & LOGIN THE SESSION
                // WITHOUT LOGGING OUT IF THE USER OPENED THE APPT. VIEW IN THE SCHEDULER THEN COLUMNS DATA WILL MISMATCH & REFERENCE ERROR WILL BE THROWN
                // TO AVIOD THIS ERROR HERE WE ARE CHECKING THE CONDITION 
                // i.e.,IF THE ERROR IS FROM THE APPT.SCHDULER COLUMNS RELATED THEN WE ARE RETURNING THE CALL WITHOUT SHOWING IT TO THE USER
                if (hasValue(arguments) && arguments.length > 1 &&  hasValue(arguments[0]) && hasValue(arguments[0].stack) && hasValue(arguments[1]) && arguments[1].contains("ProvidersApptsSched_{{providersApptsSchedGUID}}") && arguments[0].stack.contains("ReferenceError:")) {
                    responseObject.ErrorMessage += "<br> Excepton ignore List 2 Checking done...";
                    return false;
                }
                //&&&&&&&&&&&&&&&&&&&&&&&&&&&&//
                // added by Swaraj B as per Uday Kiran V 
                // skip errors from ui router transitions
                let isLocalhost = window.location.href.includes("localhost");
                const uiRouterWords = isLocalhost ? ["transition", "angular-ui-router.patch2.js"] :  ["transition", "script-libraries-1.bundle.js"];
                if (uiRouterWords.every(word => (stackTrace || []).join().includes(word))) {
                    return false;
                }
                //&&&&&&&&&&&&&&&&&&&&&&&&&&&&//
                //as per discurssion with mohan garu issue resolved.
                //when appointments window default loaded below errors are avoided.
                // if (stackTrace.indexOf("kendo.all.min.js") > 0) {
                //&&&&&&&&&&&&&&&&&&&&&&&&&&&&//
                // modified by Swaraj B, as per Uday Kiran V on 12 Jul, 2025. 
                // updating the kendo library file name and skipping the error mails when it is from kendo library
                // if (_.some(stackTrace, (el) => _.includes(el, "kendo.all.min.js"))) {
                if (_.some(stackTrace, (el) => _.includes(el, "kendo-all.bundle.js"))) {
                    return false;
                //&&&&&&&&&&&&&&&&&&&&&&&&&&&&//
                    responseObject.ErrorMessage += "<br> Excepton at Kendo library File found...";
                    var ignorelist = ["TypeError: Cannot read properties of undefined (reading 'get')", "TypeError: undefined is not an object (evaluating 'i.injector().get')", "TypeError: i.injector() is undefined"];

                    for (var ignorelistIndex = 0; ignorelistIndex < ignorelist.length; ignorelistIndex++) {
                        if (errorMessage.toLowerCase().indexOf(ignorelist[ignorelistIndex].toLowerCase()) > -1){
                            responseObject.ErrorMessage += "<br> Excepton ignore List 3 Checking done...";
                            return false;
                        }
                    }
                }

                //if (window.location.href.indexOf("localhost") > 0 || window.location.href.indexOf("192.168.0.15") > 0 || window.location.href.indexOf("192.168.0.71") > 0) {

                //    var template = '<div>' +
                //                        '<div class="popup-header">' +
                //                            '<i class="close pull-right" data-dismiss="modal" aria-hidden="true" ng-click="Cancel();"> ×</i>' +
                //                            '<label class="ModalPopupHeadings">EMR Error Log Information</label>' +
                //                        '</div>' +
                //                        '<div class="modal-body">' +
                //                            '<div class="row form-group">' +
                //                                '<div class="col-md-12 col-sm-12 col-xs-12">' +
                //                                '<textarea rows="5" class="form-control">' + errorMessage + '<br>' + stackTrace.toString() + '</textarea>' +
                //                                '</div>' +
                //                            '</div>' +
                //                        '</div>' +
                //                    '</div>';


                //    var modalPop = $injector.get('ModalPopupService');
                //    modalPop.OpenPopup(template, null, "lg").then(function () {

                //    });

                //    //no need to send the mail when in developement or testing environment
                //    return;
                //}

                //this is the ignore list of error messages 
                errorLog.errorLogServiceSendErrorMail(responseObject);
                //############SEND MAIL WITH SCREEN SHOT WHEN ERROR OCCURED BLOCK END##########################

            } catch (loggingError) {

                // For Developers - log the log-failure.
                $log.warn("Error logging failed");
                $log.log(loggingError);

            }

        },
        //################SENDING ERROR MAIL WITH SCREEN SHOT BLOCK END########################


        adminTraceLogWCFPendingRequestsMaintainence: function (reqguid, typeToPerform, MethodType, MethodUrl, Data, timeout) {
            //insert on start
            if (typeToPerform == 1) {
                var loggedDateTime;
                try {
                    loggedDateTime = $.format.date(new Date(adminGetCurrentDateAndTme()), "MM/dd/yyyy hh:mm:ss a");
                } catch (e) {
                    loggedDateTime = new Date();
                }

                //maintaining 20 requets only which are latest
                if (adminTraceLogWCFPendingRequestsList.length >= 30)
                    adminTraceLogWCFPendingRequestsList.shift();

                adminTraceLogWCFPendingRequestsList.push({
                    aMethodType: MethodType,
                    aMethodUrl: MethodUrl,
                    aData: JSON.stringify(Data),
                    atimeout: timeout,
                    areqguid: reqguid,
                    starttime: loggedDateTime,
                    netavailable: EHRISInternetAvailaible,
                    actiontype: Data.ehrAdminCurrentCallingActionType
                });

                adminTraceLogWCFAllPendingRequestsList.push({
                    aMethodType: MethodType,
                    aMethodUrl: MethodUrl,
                    atimeout: timeout,
                    areqguid: reqguid,
                    starttime: loggedDateTime,
                    netavailable: EHRISInternetAvailaible,
                    actiontype: Data.ehrAdminCurrentCallingActionType
                });
            }
            //remove on end
            else if (typeToPerform == 2) {

                //for all requests maintainence
                var loopLengthToPerform = adminTraceLogWCFAllPendingRequestsList.length;
                for (var indexInLoop = 0; indexInLoop < loopLengthToPerform; indexInLoop++) {
                    if (adminTraceLogWCFAllPendingRequestsList[indexInLoop].areqguid == reqguid) {
                        //delete adminTraceLogWCFPendingRequestsList[indexInLoop];
                        adminTraceLogWCFAllPendingRequestsList.splice(indexInLoop, 1);
                        break;
                    }
                }

                var loopLengthToPerform = adminTraceLogWCFPendingRequestsList.length;

                for (var indexInLoop = 0; indexInLoop < loopLengthToPerform; indexInLoop++) {
                    if (adminTraceLogWCFPendingRequestsList[indexInLoop].areqguid == reqguid) {
                        //delete adminTraceLogWCFPendingRequestsList[indexInLoop];
                        adminTraceLogWCFPendingRequestsList.splice(indexInLoop, 1);
                        break;
                    }
                }

            }
        },


        adminTraceLogGetWCFRequestUIDInfo: function (reqguid) {
            var returnItem = $.grep(adminTraceLogWCFAllPendingRequestsList, function (item) {
                return item.areqguid == reqguid;
            });
            return hasValue(returnItem) && returnItem.length > 0 ? returnItem[0] : undefined;
        },


        adminTraceLogGetWCFRequestUIDInfoWithData: function (reqguid) {
            var returnItem = $.grep(adminTraceLogWCFPendingRequestsList, function (item) {
                return item.areqguid == reqguid;
            });
            return hasValue(returnItem) && returnItem.length > 0 ? returnItem[0] : undefined;
        },
        openErrorInformationPopupForDevAndTestingEnvironments: function (errorDetails) {
            var template = '<div>' +
                '<div class="popup-header">' +
                '<i class="close pull-right" data-dismiss="modal" aria-hidden="true" ng-click="Cancel();"> ×</i>' +
                '<label class="ModalPopupHeadings">EMR Error Log Information</label>' +
                '</div>' +
                '<div class="modal-body">' +
                '<div class="row form-group">' +
                '<div class="col-md-12 col-sm-12 col-xs-12">' +
                // '<textarea rows="5" class="form-control">' + errorDetails.ErrorMessage + '<br>' + errorDetails.exceptionStackTrace + '</textarea>' +
                '<iframe style="height:70vh;overflow-y: auto;width: 100%;" srcdoc=\'' + (errorDetails.ErrorMessage || "").replace(/'/g, '&#39;') + '<br>' + JSON.stringify(errorDetails.exceptionStackTrace || "").replace(/'/g, '&#39;') + '\'></iframe>' +
                '</div>' +
                '</div>' +
                '</div>' +
                '</div>';
            var modalPop = $injector.get('ModalPopupService');
            modalPop.OpenPopup(template, null, "lg");
        },


        //adminTraceLogGetWCFRequestUIDInfoTakingTimeGreaterThanFiveSecs: function () {

        //	var currentDateTime;
        //	try {
        //		currentDateTime = $.format.date(new Date(adminGetCurrentDateAndTme()), "MM/dd/yyyy hh:mm:ss a");
        //	} catch (e) {
        //		currentDateTime = new Date();
        //	}

        //	var returnItem = $.grep(adminTraceLogWCFPendingRequestsList, function (item) {
        //		return hasValue(item.actiontype) && item.actiontype != adminWCFActionCallType.ASYNCHRONOUS
        //			&& hasValue(item.starttime) && DateDiff.inSeconds(item.starttime, currentDateTime) >= 5;
        //	});

        //	if (hasValue(returnItem) && returnItem.length > 0) {
        //		adminTraceLogGetWCFRequestUIDInfoTakingTimeGreaterThanFiveSecsList = adminTraceLogGetWCFRequestUIDInfoTakingTimeGreaterThanFiveSecsList.concat(returnItem);
        //	}

        //	var needToSendAsMailListLooplength = adminTraceLogGetWCFRequestUIDInfoTakingTimeGreaterThanFiveSecsList.length;

        //	if (needToSendAsMailListLooplength > 0) {

        //		var body = "";

        //		if (hasValue(EMRPracticeModel)) {
        //			body += "<B>Practice Info       : </B><br />  <br />";

        //			if (hasValue(EMRPracticeModel.PracticeName))
        //				body += "<B>Practice Name     : </B> " + EMRPracticeModel.PracticeName + "<br>";

        //			body += "<B>Practice ID     : </B> " + EMRPracticeModel.PracticeID + "<br>";

        //			if (hasValue(EMRPracticeModel.LoggedUserName))
        //				body += "<B>Logged UserName   : </B> " + EMRPracticeModel.LoggedUserName + "<br>";
        //		}

        //		body = body + "<B>Pending Requests Greater Than 5 Secs     : </B> <br/>";
        //		body = body + "<table width=\"100%\" border=\"1\" ><tr style=\"color: #FFFFFF; background-color: #333333; font-weight: bold\">";
        //		body = body + "<td>" + "Method URL" + "</td>";
        //		body = body + "<td>" + "Req.GUID" + "</td>";
        //		body = body + "<td>" + "Start Time" + "</td>";
        //		body = body + "<td>" + "Actual Time to Take(In Sec)" + "</td>";
        //		body = body + "<td>" + "Wait Time(In Sec)" + "</td>";
        //		body = body + "<td>" + "Internet Avail." + "</td>";
        //		body = body + "<td>" + "Input JSON." + "</td>";
        //		body = body + "</tr>";

        //		for (var indexInLoopMethod = 0; indexInLoopMethod < needToSendAsMailListLooplength; indexInLoopMethod++) {
        //			var currentElementRequest = adminTraceLogGetWCFRequestUIDInfoTakingTimeGreaterThanFiveSecsList[indexInLoopMethod];
        //			body = body + "<tr >";
        //			body = body + "<td>" + currentElementRequest.aMethodUrl + "</td>";
        //			body = body + "<td>" + currentElementRequest.areqguid + "</td>";
        //			body = body + "<td>" + currentElementRequest.starttime + "</td>";
        //			body = body + "<td>" + currentElementRequest.atimeout / 1000 + "</td>";
        //			var differencesecs = DateDiff.inSeconds(currentElementRequest.starttime, currentDateTime);
        //			body = body + "<td>" + differencesecs + " (" + (differencesecs / 60) + " mins.)" + "</td>";
        //			body = body + "<td>" + (currentElementRequest.netavailable ? 'Yes' : 'No') + "</td>";
        //			body = body + "<td>" + (currentElementRequest.aData) + "</td>";
        //			body = body + "</tr>";
        //		}
        //		body = body + "</table>";


        //		//clearing the list that has sent as mail
        //		adminTraceLogGetWCFRequestUIDInfoTakingTimeGreaterThanFiveSecsList = [];

        //		var subject = "";

        //		//forming the email subject
        //		if (hasValue(EMRPracticeModel)) {
        //			subject = "EMRWebUI Requests Executing Greater Than 5 Secs information For " + EMRPracticeModel.PracticeName + " - " + EMRPracticeModel.LoggedUserName;// + errorDetails.exceptionSystemName;
        //		}
        //		else {
        //			subject = "EMRWebUI Requests Executing Greater Than 5 Secs information";
        //		}


        //		html2canvas(document.body).then(function (canvas) {
        //			//converting the current html web preview as base64
        //			var screenShotData = canvas.toDataURL("image/gif");


        //			//trimming the screen shot data since to send the attachment we dont neeed the base64 in string
        //			if (hasValue(screenShotData)) {
        //				screenShotData = screenShotData.substring(screenShotData.indexOf("base64,") + "base64,".length);
        //			}


        //			//calling the mail sending method
        //			errorLog.errorLogServiceSendMail(subject, $base64.encode(body), screenShotData);

        //		});
        //	}

        //},

        // THIS IS USE TO NAVIGATE 

    };

    return errorLog;

}]);


// -------------------------------------------------- //
// -------------------------------------------------- //
